export default "__VITE_ASSET__8bIsEhVw__"